import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_atomic_crm_dark.svg";
import lightModeLogo from "./logos/logo_atomic_crm_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

// Hoang Kim Home defaults. Labels are Vietnamese runtime data shown to staff;
// the values are stable identifiers stored in the database. Keep the "won" and
// "lost" stages, the "hot" note status and the "none" task type: the dashboard
// charts and the task components filter on these values.
export const defaultCurrency = "VND";

export const defaultTitle = "Hoàng Kim Home";

export const defaultCompanySectors = [
  { value: "hotel", label: "Khách sạn" },
  { value: "serviced-apartment", label: "Căn hộ dịch vụ" },
  { value: "homestay", label: "Homestay / Villa" },
  { value: "office", label: "Văn phòng" },
  { value: "restaurant", label: "Nhà hàng / Quán cà phê" },
  { value: "school", label: "Trường học" },
  { value: "hospital", label: "Bệnh viện / Phòng khám" },
  { value: "contractor", label: "Nhà thầu / Thiết kế nội thất" },
  { value: "other", label: "Khác" },
];

export const defaultDealStages = [
  { value: "new", label: "Mới" },
  { value: "measuring-scheduled", label: "Hẹn đo" },
  { value: "measured", label: "Đã đo" },
  { value: "quoted", label: "Đã báo giá" },
  { value: "deposit-paid", label: "Đã cọc" },
  { value: "in-production", label: "Đang may" },
  { value: "install-scheduled", label: "Hẹn lắp" },
  { value: "won", label: "Hoàn tất" },
  { value: "lost", label: "Hủy" },
];

export const defaultDealPipelineStatuses = [
  "deposit-paid",
  "in-production",
  "install-scheduled",
  "won",
];

export const defaultDealCategories = [
  { value: "fabric-curtain", label: "Rèm vải" },
  { value: "roller-blind", label: "Rèm cuốn" },
  { value: "venetian-blind", label: "Rèm sáo" },
  { value: "zebra-blind", label: "Rèm cầu vồng" },
  { value: "mosquito-screen", label: "Cửa lưới chống muỗi" },
  { value: "mattress", label: "Nệm" },
  { value: "bedding", label: "Chăn ga gối" },
  { value: "hotel-bedding", label: "Chăn ga khách sạn" },
  { value: "drying-rack", label: "Giá phơi" },
  { value: "other", label: "Khác" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Mới hỏi", color: "#7dbde8" },
  { value: "warm", label: "Đang quan tâm", color: "#e8cb7d" },
  { value: "hot", label: "Sắp chốt", color: "#e88b7d" },
  { value: "in-contract", label: "Đã chốt", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Không phân loại" },
  { value: "call", label: "Gọi điện" },
  { value: "zalo", label: "Nhắn Zalo" },
  { value: "measure", label: "Đi đo" },
  { value: "quote", label: "Gửi báo giá" },
  { value: "install", label: "Lắp đặt" },
  { value: "payment", label: "Thu tiền" },
  { value: "warranty", label: "Bảo hành" },
  { value: "follow-up", label: "Chăm sóc lại" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
